import { CUSTOM_REPORT_ID_PREFIX, ReportSpec } from './reportCatalog';

/**
 * Kullanıcının kurduğu rapor kartlarının (ReportSpec) localStorage deposu.
 * Layout/gizli kart depolarıyla aynı desen: cihaz bazlı kalıcılık.
 */
const CUSTOM_REPORTS_STORAGE_KEY = 'dashboard_custom_reports_v1';

export const loadCustomReports = (): ReportSpec[] => {
  try {
    const raw = localStorage.getItem(CUSTOM_REPORTS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (s: unknown): s is ReportSpec =>
        !!s &&
        typeof s === 'object' &&
        typeof (s as ReportSpec).id === 'string' &&
        (s as ReportSpec).id.startsWith(CUSTOM_REPORT_ID_PREFIX) &&
        typeof (s as ReportSpec).dataSource === 'string' &&
        typeof (s as ReportSpec).metric === 'string'
    );
  } catch {
    return [];
  }
};

const persist = (reports: ReportSpec[]): void => {
  try {
    localStorage.setItem(CUSTOM_REPORTS_STORAGE_KEY, JSON.stringify(reports));
  } catch {
    /* storage dolu olabilir - sessiz geç */
  }
};

/** Var olan id güncellenir, yoksa sona eklenir; güncel listeyi döner */
export const upsertCustomReport = (spec: ReportSpec): ReportSpec[] => {
  const reports = loadCustomReports();
  const index = reports.findIndex((r) => r.id === spec.id);
  const next = index >= 0
    ? reports.map((r) => (r.id === spec.id ? spec : r))
    : [...reports, spec];
  persist(next);
  return next;
};

export const deleteCustomReport = (id: string): ReportSpec[] => {
  const next = loadCustomReports().filter((r) => r.id !== id);
  persist(next);
  return next;
};
